import { UnreceivedProduct, WrongProductData } from '../../PendingReceivementsTypes'
import Modal from 'src/components/Modal'
import CardUnreceivedProduct from '../CardUnreceivedProduct/CardUnreceivedProduct'
import * as S from './UnreceivedProductsListModal.styles'

interface UnreceivedProductsListModalProps {
  show: boolean
  onClose: () => any
  unreceivedProducts: UnreceivedProduct[]
  receivementId: string
  wrongProductData: WrongProductData
  badge: string
}

const UnreceivedProductsListModal: React.FC<UnreceivedProductsListModalProps> = (
  {
    show, onClose, unreceivedProducts, receivementId, wrongProductData, badge,
  },
) => (
  <Modal
    show={show}
    testId='unreceived-products-list-modal-test-id'
    centered
    title='Associação de produtos'
    closeButtonAction={onClose}
    closedButton
    size='xl'
    body={(
      <S.Container>
        {unreceivedProducts.map((product) => (
          <CardUnreceivedProduct
            key={product.idModel}
            receivementId={receivementId}
            idArItem={product.idArItem}
            currentIdModel={product.idModel}
            newIdModel={wrongProductData.modelId}
            invoiceNumber={product.invoiceNumber}
            invoiceProductName={product.invoiceProductName}
            stockProductName={wrongProductData.description}
            productCode={wrongProductData.productCode}
            invoiceUnitType={product.invoiceUnitType}
            originalQuantity={product.originalQuantity}
            convertedQuantity={product.convertedQuantity}
            badge={badge}
            onCloseProductListModal={onClose}
          />
        ))}
      </S.Container>
      )}
  />
)

export default UnreceivedProductsListModal
